import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { useAvivaDispatch, useAvivaSelector } from "@redux/hook";
import { updateFloatIconShow } from "@redux/slices/SHIELD_STARTER/step1Slice";
import VideoModal from "@pages/ShieldStarter/Components/Modals/VideoModal";
import Modal from "@components/_Revamp/Modal";
import floatImage from "@assets/images/float-icon.svg";
import floatImageDesktop from "@assets/images/float-icon-desktop-left.svg";

import React, { useEffect, useState } from "react";

const FloatIconContainer = styled.div<{bottom: string}>`
  position: fixed;
  bottom: 0px;
  left: 0px;
  z-index: 10;
  width: 16vw;
  @media screen and (max-width: 767px) {
    position: fixed;
    bottom: ${({bottom})=>bottom};
    left: inherit;
    right: 16px;
    width: auto;
  }
`;

const floatIconCloseCss = css`
  cursor: pointer;
  position: absolute;
  top: 30%;
  right: 0;
  @media screen and (min-width: 768px) {
    top: 35%;
    right: inherit;
    left: 12%;
    transform: scale(1.5);
  }
`;

const FloatIconImage = styled.img`
  @media screen and (min-width: 768px) {
    display: none;
  }
  @media screen and (max-width: 767px) {
    clip-path: inset(20% 7% 10% 13%);
    cursor: pointer;
    position: relative;
    // left: 25px;
    // right: 24px;
    /* bottom: -24px; */
    width: 100%;
  }
`;
const FloatIconImage2 = styled.img`
  @media screen and (max-width: 767px) {
    display: none;
  }
  @media screen and (min-width: 768px) {
    cursor: pointer;
    position: relative;
    right: 0;
    bottom: -7px;
    width: 100%;
  }
`;
export default function FloatingIcon() {
  const [videoModalVisible, setVideoModalVisible] = useState<boolean>(false);
  const dispatch = useAvivaDispatch();
  const showFloatIcon = useAvivaSelector(
    (state) => state.shieldStarterStep1.floatIconShow
  );
  const notifications = useAvivaSelector(
    (state) => state.shieldStarterStep1.notifications
  );
  const [addHeight, setHeight] = useState(0);

  useEffect(()=>{
    const toastElement:any =  document.getElementById('toast');
    if (toastElement) setHeight(toastElement.getBoundingClientRect().height);
  }, [notifications])

  const addBottom = notifications.length > 0 ? addHeight + 48 + "px": "20px";

  return (
    <>
      {showFloatIcon && (
        <>
          {videoModalVisible && (
            <Modal
              show={videoModalVisible}
              onClose={() => setVideoModalVisible(false)}
            >
              <VideoModal />
            </Modal>
          )}
          <FloatIconContainer bottom={addBottom}>
            <div style={{ position: "relative" }}>
              <FloatIconImage
                onClick={(e) => {
                  e.stopPropagation();
                  setVideoModalVisible(true);
                }}
                src={floatImage}
                alt="Andy's story video"
              />
              <FloatIconImage2
                onClick={(e) => {
                  e.stopPropagation();
                  setVideoModalVisible(true);
                }}
                src={floatImageDesktop}
                alt="Andy's story video"
              />
              <svg
                className={floatIconCloseCss}
                onClick={(e) => {
                  e.stopPropagation();
                  dispatch(updateFloatIconShow(false));
                }}
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  width="16"
                  height="16"
                  rx="8"
                  fill="white"
                  fill-opacity="0.9"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5.44124 5.07571C5.3403 4.97476 5.17665 4.97476 5.07571 5.07571C4.97476 5.17665 4.97476 5.3403 5.07571 5.44124L7.63447 8L5.07571 10.5588C4.97477 10.6597 4.97477 10.8234 5.07571 10.9243C5.17665 11.0252 5.34031 11.0252 5.44125 10.9243L8 8.36554L10.5588 10.9243C10.6597 11.0252 10.8233 11.0252 10.9243 10.9243C11.0252 10.8233 11.0252 10.6597 10.9243 10.5588L8.36554 8L10.9243 5.44125C11.0252 5.34031 11.0252 5.17665 10.9243 5.07571C10.8234 4.97477 10.6597 4.97477 10.5588 5.07571L8 7.63447L5.44124 5.07571Z"
                  fill="#434343"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5.38215 5.13593C5.31376 5.06754 5.20286 5.06754 5.13447 5.13593C5.06607 5.20433 5.06607 5.31522 5.13447 5.38362L7.75216 8.00131L5.13448 10.619C5.06608 10.6874 5.06608 10.7983 5.13448 10.8667C5.20287 10.9351 5.31376 10.9351 5.38216 10.8667L7.99984 8.24899L10.6175 10.8667C10.6859 10.9351 10.7968 10.9351 10.8652 10.8667C10.9336 10.7983 10.9336 10.6874 10.8652 10.619L8.24753 8.00131L10.8652 5.38362C10.9336 5.31523 10.9336 5.20434 10.8652 5.13594C10.7968 5.06754 10.6859 5.06754 10.6175 5.13594L7.99984 7.75362L5.38215 5.13593ZM5.01662 5.01808C5.1501 4.8846 5.36652 4.8846 5.5 5.01808L7.99984 7.51792L10.4997 5.01809C10.6332 4.8846 10.8496 4.8846 10.9831 5.01809C11.1165 5.15157 11.1165 5.36799 10.9831 5.50148L8.48323 8.00131L10.9831 10.5011C11.1165 10.6346 11.1165 10.851 10.9831 10.9845C10.8496 11.118 10.6331 11.118 10.4997 10.9845L7.99984 8.48469L5.50001 10.9845C5.36653 11.118 5.15011 11.118 5.01662 10.9845C4.88314 10.851 4.88314 10.6346 5.01662 10.5011L7.51645 8.00131L5.01662 5.50147C4.88313 5.36799 4.88313 5.15157 5.01662 5.01808Z"
                  fill="#434343"
                />
              </svg>
            </div>
          </FloatIconContainer>
        </>
      )}
    </>
  );
}
